module.exports = __webpack_public_path__ + "img/Kikkoman.772bc7c0.jpg";